export default {
  methods: {
    russianValidate() {
      if (this.rus) {
        const pattern = /^[а-яА-ЯёЁ/-]+$/

        if (!pattern.test(String(this.inputValue).trim())) {
          this.message = '​Используйте только символы русского алфавита!'
          this.status = 'error'
          return false
        } else {
          this.message = ''
          this.status = 'done'
          this.isEmptyValue = false
          return true
        }
      } else {
        this.message = ''
        this.status = 'done'
        this.isEmptyValue = true
        return true
      }
    },
  },
}
